// ============================================
// HOOK - Onboarding Options
// ============================================

import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '@almacenes/core';

interface OnboardingOption {
  value: string;
  label: string;
}

interface OnboardingOptions {
  leadSources: OnboardingOption[];
  storeTypes: OnboardingOption[];
}

/**
 * Hook para obtener las opciones de onboarding (leadSources y storeTypes)
 */
export const useOnboardingOptions = () => {
  return useQuery<OnboardingOptions>({
    queryKey: ['onboarding-options'],
    queryFn: async () => {
      const { data } = await axiosClient.get<OnboardingOptions>('/auth/signup/onboarding-options');
      return data;
    },
    staleTime: Infinity, // Las opciones no cambian frecuentemente
    gcTime: 1000 * 60 * 60 * 24, // 24 horas
  });
};
